import { basketReducer } from '../../basket/reducers/BasketReducer';
import basketSaga from '../../basket/sagas/BasketSagas';
const loadBasketModule = () => ({
    id: 'Basket',
    reducerMap: {
        basket: basketReducer,
    },
    sagas: [basketSaga],
});
export default loadBasketModule;
